/* eslint-disable no-console */
const loggerThemes = {
    info: 'padding: 4px 2px; background: var(--md-gray-500); color: var(--md-foreground);',
    message: 'padding: 4px 2px; background: lightblue; color: var(--md-foreground);',
    misc: 'padding: 4px 2px; background: #f7f7ff; color: var(--md-foreground);',
    success: 'padding: 4px 2px; background: lightgreen; color: var(--md-foreground);',
    error: 'padding: 4px 2px; background: #bb1111; color: var(--md-background);',
    warn: 'padding: 4px 2px; background: yellow; color: var(--md-foreground);',
}

/**
 * Logs to console in different colors
 */
export const logger = {
    info: message => console.log(`%c Info — ${message} `, loggerThemes.info),
    log: message => console.log(`%c Log — ${message} `, loggerThemes.message),
    message: message =>
        console.log(`%c Message —  ${message}`, loggerThemes.misc),
    success: message =>
        console.log(`%c Success — ${message} `, loggerThemes.success),
    error: message =>
        console.log(`%c Failed — ${message} `, loggerThemes.error),
    warn: message => console.log(`%c Warning — ${message} `, loggerThemes.warn),
}
